
import { Charity, Project } from '../../../Shared/types';
import { ColorBadge } from '../../../Shared/UI/ColorBadge';
import ProjectIcon from './ProjectIcon';

export default function ProjectLogo({
  project,
  charity,
  size = 'md',
}: {
  project: Project;
  charity: Charity;
  size?: 'md' | 'lg'
}) {
  return (
    <ColorBadge
      color={charity?.brand_color || null}
      size={size}
      opacity={project.default ? 0.5 : undefined}
      className="!rounded"
    >
      <ProjectIcon project={project} className="text-xl" />
    </ColorBadge>
  );
}
